import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import clsx from 'clsx';

type SolutionPropsType = {
    list: { description: string }[];
    listAudit: { title: string; description: string }[];
    listMedia: { description: string }[];
    listMediaParagraph: { description: string }[];
    listParagraph: { description: string }[];
    listPage: { description: string }[];
    listAnalyse: { description: string }[];
    listDifficulties: { number: number; text: string }[];
};
const Solution = ({
    list,
    listAudit,
    listMedia,
    listMediaParagraph,
    listParagraph,
    listPage,
    listAnalyse,
    listDifficulties,
}: SolutionPropsType) => {
    return (
        <div className="ck10-solution">
            <FullWrapper isMargin={false} className="ck10-solutionCase">
                <div className="ck10-solutionWrapper">
                    <div className="ck10-solutionInner">
                        <div className="ck10-solutionLeft">
                            <div className="ck10-solutionTitle">Решение</div>
                        </div>
                        <div className="ck10-solutionRight">
                            Работали по&nbsp;HADI-циклам и&nbsp;за&nbsp;год протестировали 3000+
                            гипотез
                        </div>
                    </div>
                    <div className="ck10-solutionInner">
                        <div className="ck10-solutionLeft">
                            <div className="ck10-solutionDescription">
                                Наша команда интернет-маркетологов работает по&nbsp;HADI-циклам.
                                Такой подход позволяет быстро генерировать и&nbsp;проверять
                                гипотезы. В&nbsp;течение недели тестировали по&nbsp;2&nbsp;&mdash;
                                3&nbsp;гипотезы в&nbsp;разных рекламных каналах.
                                На&nbsp;еженедельных спринтах оценивали результаты, вносили
                                корректировки, оставляли рабочие варианты и&nbsp;переходили
                                к&nbsp;тестированию новых гипотез. Всего мы&nbsp;отработали более
                                3000&nbsp;гипотез.
                            </div>
                        </div>
                    </div>
                    <div className="ck10-solutionInner">
                        <div className="ck10-solutionLeft">
                            <div className="ck10-solutionSubtitle">Аудит предыдущих запусков</div>
                            <div className="ck10-solutionParagraf">
                                Проанализировали 13&nbsp;рекламных кабинетов клиента и&nbsp;увидели:
                            </div>
                            <div className="ck10-solutionListAudit">
                                {listAudit &&
                                    listAudit.map(item => (
                                        <div className="ck10-solutionItemAudit" key={item.title}>
                                            <div
                                                className="ck10-solutionTextAudit"
                                                dangerouslySetInnerHTML={{ __html: item.title }}
                                            ></div>
                                            <div
                                                className="ck10-solutionDescriptionAudit"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            ></div>
                                        </div>
                                    ))}
                            </div>
                            <div className="ck10-solutionParagraf">
                                На&nbsp;основе этих данных разработали стратегию
                                интернет-продвижения в&nbsp;Яндекс Директ для каждого&nbsp;ЖК,
                                сгруппировали гипотезы с&nbsp;приоритетами и&nbsp;составили новый
                                медиаплан. Спрогнозировали количество заявок, CPL, клики, CR.
                                Запланировали объем лидов на&nbsp;20% выше того, что было раньше.
                                При этом бюджет мы&nbsp;оставили тот&nbsp;же, что и&nbsp;был
                                в&nbsp;прошлых запусках.
                            </div>
                            <div
                                className={clsx(
                                    'ck10-solutionSubtitle',
                                    'ck10-solutionSubtitleMargin40'
                                )}
                            >
                                Первый запуск рекламных кампаний
                            </div>
                            <div className="ck10-solutionList">
                                {list &&
                                    list.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="ck10-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                            <div className="ck10-solutionListMedia">
                                {listMedia &&
                                    listMedia.map(item => (
                                        <div
                                            key={item.description}
                                            className="ck10-solutionItemMedia"
                                        >
                                            <div className="ck10-solutionCircleMedia"></div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                                className="ck10-solutionTextMedia"
                                            ></div>
                                        </div>
                                    ))}
                            </div>
                            <div className="ck10-solutionListParagraf">
                                {listMediaParagraph &&
                                    listMediaParagraph.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="ck10-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                            <div
                                className={clsx(
                                    'ck10-solutionSubtitle',
                                    'ck10-solutionSubtitleMargin60'
                                )}
                            >
                                Поменяли посадочные страницы
                            </div>
                            <div className="ck10-solutionList">
                                {listParagraph &&
                                    listParagraph.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="ck10-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                            <div className="ck10-solutionListMedia">
                                {listPage &&
                                    listPage.map(item => (
                                        <div
                                            key={item.description}
                                            className="ck10-solutionItemMedia"
                                        >
                                            <div className="ck10-solutionCircleMedia"></div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                                className="ck10-solutionTextMedia"
                                            ></div>
                                        </div>
                                    ))}
                            </div>
                            <div className="ck10-solutionParagraf">
                                Лучше всего сработал Мастер Кампаний с&nbsp;автотаргетингом
                                на&nbsp;основе целевых запросов. В&nbsp;результате получили
                                на&nbsp;250% больше целевых заявок по&nbsp;сравнению с&nbsp;другими
                                гипотезами и&nbsp;по&nbsp;цене всего на&nbsp;20-30% выше, чем
                                на&nbsp;ЖК комфорт-класса.
                            </div>
                            <div
                                className={clsx(
                                    'ck10-solutionSubtitle',
                                    'ck10-solutionSubtitleMargin60'
                                )}
                            >
                                Наладили регулярный анализ
                            </div>
                            <div className="ck10-solutionList">
                                {listAnalyse &&
                                    listAnalyse.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="ck10-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className={clsx('ck10-solutionSubtitle', 'ck10-solutionSubtitleMargin60')}>
                        Массово запустили Мастер кампании
                    </div>
                    <div className="ck10-solutionInner">
                        <div className="ck10-solutionLeft">
                            <div className="ck10-solutionParagraf">
                                Для увеличения объема лидов запустили Мастер кампаний
                                в&nbsp;различных вариациях: по&nbsp;общим запросам, по&nbsp;бренду
                                застройщика, по&nbsp;каждому&nbsp;ЖК, по&nbsp;количеству комнат
                                и&nbsp;т.&nbsp;д. В&nbsp;результате получили более&nbsp;30%
                                от&nbsp;количества всех качественных лидов. CPL стал дешевле
                                в&nbsp;среднем на&nbsp;30%.
                            </div>
                        </div>
                        <div className={clsx('ck10-solutionRight', 'ck10-solutionRightTop')}>
                            За&nbsp;12&nbsp;месяцев&nbsp;настроили&nbsp;и&nbsp;запустили 200+
                            рекламных кампаний с&nbsp;сотнями различных креативов.
                        </div>
                    </div>
                    <div className="ck10-solutionInner">
                        <div className="ck10-solutionLeft">
                            <div className="ck10-solutionColorSubtitle">Сложности проекта</div>
                            {listDifficulties &&
                                listDifficulties.map((item, index) => (
                                    <div key={index} className="ck10-solutionListDiff">
                                        <div className="ck10-solutionListDiffNumber">
                                            {item.number}
                                        </div>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: item.text }}
                                            className="ck10-solutionListDiffText"
                                        />
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
